module.exports = fox._r("images/editor/sc-ico-sprite.png", __webpack_public_path__ + "_/_/_/common/frame/images/editor/sc-ico-sprite.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/editor/sc-ico-sprite.png
// module id = 138
// module chunks = 2